"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _GridList = _interopRequireDefault(require("@material-ui/core/GridList"));

var _GridListTile = _interopRequireDefault(require("@material-ui/core/GridListTile"));

var _ProductImage = _interopRequireDefault(require("@sprinx/react-com/ProductImage"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _reactYoutube = _interopRequireDefault(require("react-youtube"));

var _reactGlobalize = require("@sprinx/react-globalize");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _productVideo;

  return {
    root: {},
    gridList: {
      width: '100%'
    },
    productVideo: (_productVideo = {
      padding: theme.spacing(3),
      maxHeight: 'unset'
    }, (0, _defineProperty2.default)(_productVideo, theme.breakpoints.down('sm'), {
      padding: theme.spacing(2)
    }), (0, _defineProperty2.default)(_productVideo, theme.breakpoints.down('xs'), {
      padding: 0,
      marginBottom: theme.spacing(2)
    }), _productVideo)
  };
}, {
  name: 'ProductDetailMedia'
});

function ProductDetailMedia(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var locale = (0, _reactGlobalize.usePreferredLocale)();
  var classes = useStyles({
    classes: pClasses
  });
  var desktopBreakpoint = (0, _useMediaQuery.default)('(min-width:1034px)');
  var image = product.image,
      media = product.media,
      name = product.name,
      _product$extra$media = product.extra.media,
      eMedia = _product$extra$media === void 0 ? [] : _product$extra$media;

  var _ref2 = eMedia.find(function (m) {
    return m.locale === locale;
  }) || {},
      _ref2$videos = _ref2.videos,
      videos = _ref2$videos === void 0 ? [] : _ref2$videos;

  var allMedia = _react.default.useMemo(function () {
    if (!image && (!media || !media.length)) return [];
    var imgd = image ? {
      src: image,
      alt: name,
      type: 'image',
      index: 0
    } : {};
    return [imgd].concat((0, _toConsumableArray2.default)(media || [])).filter(function (i) {
      return !!i.src;
    }).map(function (i, index) {
      return (0, _extends2.default)({
        index: index
      }, i);
    });
  }, [image, name, media]);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_GridList.default, {
    cellHeight: 'auto',
    className: classes.gridList,
    cols: 2
  }, allMedia.map(function (i, index) {
    return /*#__PURE__*/_react.default.createElement(_GridListTile.default, {
      key: index.toString(),
      cols: desktopBreakpoint ? 1 : 2,
      rows: 1,
      className: classes.listTile
    }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
      src: i.src,
      alt: i.alt,
      type: i.type,
      size: "big",
      className: classes.productImage
    }));
  }), videos.map(function (src, index) {
    return /*#__PURE__*/_react.default.createElement(_GridListTile.default, {
      key: index.toString(),
      cols: desktopBreakpoint ? 1 : 2,
      rows: 1,
      className: classes.listTile
    }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
      src: src,
      alt: name,
      type: 'video',
      size: "big",
      className: (0, _clsx.default)(classes.productImage, classes.productVideo),
      mediaTypeComponents: {
        video: ProductImageVideoComponent // eslint-disable-line no-use-before-define

      }
    }));
  })));
}

process.env.NODE_ENV !== "production" ? ProductDetailMedia.propTypes = {
  classes: _propTypes.default.shape({
    gridList: _propTypes.default.string,
    listTile: _propTypes.default.string,
    productImage: _propTypes.default.string,
    productVideo: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    extra: _propTypes.default.shape({
      media: _propTypes.default.arrayOf(_propTypes.default.shape({}))
    }),
    image: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]),
    media: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    name: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string.isRequired,
      text: _propTypes.default.string
    }))
  })
} : void 0;
ProductDetailMedia.defaultProps = {
  classes: undefined,
  className: undefined,
  product: undefined
};
var _default = ProductDetailMedia;
exports.default = _default;
var useStylesVideoComponent = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      height: 0,
      maxHeight: '100%',
      paddingBottom: '50%',
      position: 'relative',
      backgroundColor: theme.palette.background.video
    },
    videoPlayer: {
      width: '100%',
      height: '100%',
      backgroundColor: theme.palette.common.black,
      position: 'absolute'
    }
  };
}, {
  name: 'ProductImageVideoComponent'
});

function ProductImageVideoComponent(_ref3) {
  var pClasses = _ref3.classes,
      className = _ref3.className,
      src = _ref3.src,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["classes", "className", "src"]);
  var classes = useStylesVideoComponent({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_reactYoutube.default, {
    className: classes.videoPlayer,
    videoId: function (s) {
      if (s.startsWith('http') && s.includes('youtube')) return new URL(s).searchParams.get('v');
      if (s.startsWith('http')) return (s.match(/([^/]+)$/) || ['', ''])[1];
      return s;
    }(src),
    opts: {
      playerVars: {
        autoplay: 0
      }
    }
  }));
}

process.env.NODE_ENV !== "production" ? ProductImageVideoComponent.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    videoPlayer: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  src: _propTypes.default.string
} : void 0;
ProductImageVideoComponent.defaultProps = {
  classes: undefined,
  className: undefined,
  src: undefined
};